import React, { useState } from 'react';
import SearchFilter from 'components/pld/shared/filters/SearchFilter';
import Chip from 'components/atoms/Chip';
import Icons from 'components/atoms/Icons';

import CategoryPanel, { SEARCH_CATEGORIES, getCategoryIconId } from './CategoryPanel';

const SearchModal = (): React.JSX.Element => {
  const [query, setQuery] = useState('');
  const [categoryPanelOpen, setCategoryPanelOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const onQueryInputChange = (value: string) => setQuery(value);
  const updateQuery = (value: string) => {
    setQuery(value);
  };

  const openCategoryPanel = () => {
    document.body.classList.add('category-panel-open');
    setCategoryPanelOpen(true);
  };

  const closeCategoryPanel = () => {
    document.body.classList.remove('category-panel-open');
    setCategoryPanelOpen(false);
  };

  const selectCategory = (id: string) => {
    setSelectedCategory(id === 'all' ? null : id);
    closeCategoryPanel();
  };

  const removeCategoryFilter = () => {
    setSelectedCategory(null);
  };

  const selectedCategoryData = SEARCH_CATEGORIES.find(
  (c) => c.id === selectedCategory
);

  return (
    <div className="search-bar-container global-search overhauled">
      <div className="jss-inner-container">
        <div className="search-bar">
          <div className="search-field-group">
            <div className="filter-btn-container">
              <div className="search-bar-btn">
                <SearchFilter
                  minimumCharacters={2}
                  onQueryInputChange={onQueryInputChange}
                  placeholder="Type Keyword"
                  queryInputValue={query}
                  searchType="global"
                  updateQuery={updateQuery}
                />
              </div>
            </div>
            <button
              className="btn-primary no-icon search-btn"
              onClick={() => updateQuery(query)}
            >
              Search
            </button>
          </div>

          <button
            type="button"
            className="filter-category-btn"
            aria-expanded={categoryPanelOpen}
            onClick={openCategoryPanel}
          >
            <span className="filter-icon">
              <Icons id="icon-filters"></Icons>
            </span>
            <span className="filter-category-label">Filter by category</span>
            <span className="filter-chevron">
              <Icons id="pld-chevron-right" className="chevron-right"></Icons>
            </span>
          </button>
        </div>

       {selectedCategory && selectedCategoryData && (
          <div className="selected-filters-list">
            <Chip
              leadingIcon={getCategoryIconId(selectedCategoryData, true)}
              label={selectedCategoryData.label}
              filterName={selectedCategory}
              filterCategory="category"
              removeFilter={removeCategoryFilter}
            />
          </div>
        )}
      </div>

      <div
              className="category-overlay"
        onClick={(e) => {
          if (categoryPanelOpen) {
            const targ = e.target as HTMLElement;
            !targ.closest('.category-panel-wrapper') && closeCategoryPanel();
          }
        }}
      >
        <CategoryPanel
          active={categoryPanelOpen}
          categories={SEARCH_CATEGORIES}
          selectedCategory={selectedCategory ?? 'all'}
          onSelect={selectCategory}
          onClose={closeCategoryPanel}
        />
      </div>
    </div>
  );
};

export default SearchModal;